// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__DQorR","animloader":"loader_animloader__CLCiH","spinner":"loader_spinner__wgng6","rotation":"loader_rotation__z0xA8"};